import { Component, OnInit, Inject, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Reason } from '../../../models/Reason';
import { getReasons } from '../../../state/reason/reason.actions';
import { selectReasons } from '../../../state/reason/reason.selector';
import { addCoinTransaction } from '../../../state/coin-transaction/coin-transaction.actions';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule } from '@angular/forms';
import { updateCoins } from '../../../state/customer/customer.actions';
import { CustomerState } from '../../../state/customer/customer.reducer';

export interface AddCoinTransactionModel {
  reflexCustomerNo: number;
  userName: string;
  reasonId: number;
  amount: number;
}

export interface DialogData {
  reflexCustomerNo: string;
  salesUserCurrentCoins?: number | null;
}

@Component({
  selector: 'app-add-coins-dialog',
  templateUrl: './add-coins-dialog.component.html',
  styleUrl: './add-coins-dialog.component.css',
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    FormsModule
  ]
})
export class AddCoinsDialogComponent implements OnInit {
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  amount: number | null = null;
  selectedReason: Reason | null = null;
  reasons$: Observable<Reason[]>;
  salesUserCurrentCoins: number | null = null;

  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<AddCoinsDialogComponent>,
    private customerStore: Store<{ customer: CustomerState}>
  ) {
    this.reasons$ = this.store.select(selectReasons).pipe(
      map((r: Reason[] | null) => {
        if (!r) return [];
        return r.filter(reason => !reason.reasonText.includes('Generiert'));
      })
    );
    this.salesUserCurrentCoins = this.data.salesUserCurrentCoins ?? null;
  }

  ngOnInit(): void {
    this.store.dispatch(getReasons());
    this.reasons$.subscribe(reasons => {
      if (reasons && reasons.length > 0 && !this.selectedReason) {
        this.selectedReason = reasons[0];
      }
    });
    console.log('Sales User Current Coins in Dialog:', this.salesUserCurrentCoins);
  }

  addTransaction(): void {
    if (this.amount && this.selectedReason) {
      const userName = localStorage.getItem('userName') || '';
      const transaction: AddCoinTransactionModel = {
        reflexCustomerNo: Number(this.data.reflexCustomerNo),
        userName,
        reasonId: this.selectedReason.id,
        amount: this.amount
      };
      this.store.dispatch(addCoinTransaction({ coinTransaction: transaction }));
      this.customerStore.dispatch(updateCoins({
        request: {
          userName: localStorage.getItem('userName') || '',
          coins: this.amount,
          operation: this.selectedReason.reasonText === 'Abzug' ? 'subtract' : 'add',
        }
      }));
      console.log('AddCoinTransaction dispatched:', transaction);
      this.dialogRef.close();
    }
  }
}
